// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"numbers-1-1"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12 19V4.5L11.5 4.5L9.5 6","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Numbers11Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'numbers-1-1',
    ref,
    icon: element,
  },
));

Numbers11Icon.displayName = 'Numbers11Icon';

export default Numbers11Icon;
